import { useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import { CalendlyWidget } from "~/components/3rd-party/CalendlyWidget";
import { Button } from "~/components/ui/button";
import { CALENDLY_URL } from "~/constants/index";

interface RegisterDemoWidgetProps {
  email: string;
  name: string;
  onBack: () => void;
}

const CALENDLY_DEMO_URL = `${CALENDLY_URL}?hide_landing_page_details=1`;

export const RegisterDemoWidget = ({
  email,
  name,
  onBack,
}: RegisterDemoWidgetProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const initializeCalendly = () => {
      const calendly = window.Calendly;
      const parentElement = containerRef.current;

      if (calendly?.initInlineWidget && parentElement) {
        calendly.initInlineWidget({
          url: CALENDLY_DEMO_URL,
          parentElement,
          prefill: {
            name,
            email,
          },
        });
      }
    };

    if (window.Calendly?.initInlineWidget) {
      initializeCalendly();
    } else {
      const checkCalendly = setInterval(() => {
        if (window.Calendly?.initInlineWidget) {
          clearInterval(checkCalendly);
          initializeCalendly();
        }
      }, 100);

      return () => {
        clearInterval(checkCalendly);
        const parentElement = containerRef.current;
        if (parentElement) parentElement.innerHTML = "";
      };
    }

    return () => {
      const parentElement = containerRef.current;
      if (parentElement) parentElement.innerHTML = "";
    };
  }, [email, name]);

  return (
    <div className="flex flex-col gap-4">
      <CalendlyWidget />
      <div
        data-testid="calendly-inline-container"
        ref={containerRef}
        className="w-full max-w-none mx-auto"
        style={{ minWidth: 1200, height: 900 }}
      />
      <div className="flex justify-center">
        <Button variant="secondary" onClick={onBack}>
          <FormattedMessage id="auth.register.back" defaultMessage="Back" />
        </Button>
      </div>
    </div>
  );
};
